var _excluded = ["error", "className", "disabled", "onChange", "value", "showCounter", "reference", "warning", "description", "maxLength", "data-qa"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import PropTypes from "prop-types";
import InputSubtext from "@components/input-subtext";
import { joinCn } from "@ati/uti";
var Textarea = _ref => {
  var {
      error = false,
      className,
      disabled = false,
      onChange,
      value = "",
      showCounter = true,
      reference,
      warning = false,
      description,
      maxLength = 113,
      "data-qa": dataQa = "textarea"
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-qa": dataQa
  }, /*#__PURE__*/React.createElement("div", {
    className: "glz-textarea-wrapper container-width"
  }, /*#__PURE__*/React.createElement("textarea", _extends({
    maxLength: maxLength
  }, props, {
    onChange: onChange,
    className: joinCn("glz-textarea", error && "glz-is-error", warning && "glz-is-warning", showCounter && "glz-has-counter"),
    disabled: disabled,
    value: value,
    ref: reference
  })), showCounter && /*#__PURE__*/React.createElement("div", {
    className: "glz-counter-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "glz-counter\n              ".concat(maxLength - value.length >= 0 ? "" : "glz-is-negative")
  }, maxLength - value.length))), /*#__PURE__*/React.createElement(InputSubtext, {
    error: error,
    warning: warning,
    description: description
  }));
};
Textarea.propTypes = {
  /** Заблокированное состояние */
  disabled: PropTypes.bool,
  /** Если true/false, то подсветится поле, если приходит строка, то подсветится поле и выведется текст */
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Значение поля */
  value: PropTypes.string,
  /** Функция, вызываемая при изменении текста поля */
  onChange: PropTypes.func,
  /** Кастомный класс для оболочки */
  className: PropTypes.string,
  /** Максимально доступное кол-во символов */
  maxLength: PropTypes.number,
  /** Показать максимальное кол-во символов */
  showCounter: PropTypes.bool,
  /** Ссылка на элемент */
  reference: PropTypes.func,
  /** Если true/false, то подсветится поле, если приходит строка, то подсветится поле и выведется текст */
  warning: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  /** Описание под полем */
  description: PropTypes.string,
  /** data-qa атрибут для тестирования */
  "data-qa": PropTypes.string
};
export default Textarea;